"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { Text as t } from "../Text/Text.mjs";
import { BadgeButton as n } from "./BadgeButton.mjs";
import { useState as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { cva as o } from "class-variance-authority";
//#region src/components/atoms/Badge/Badge.tsx
var s = o("flex justify-center items-center", {
	variants: {
		size: {
			small: "px-1.5 py-0.5",
			medium: "px-1.5 py-0.5",
			large: "px-2 py-1.5"
		},
		color: {
			neutral: "bg-white text-gray-900",
			info: "bg-blue-700 text-white",
			success: "bg-green-700 text-white",
			warning: "bg-pink-700 text-white"
		},
		shape: {
			rounded: "rounded-full",
			square: "rounded"
		}
	},
	defaultVariants: {
		size: "small",
		color: "info"
	}
}), c = o("fill-current", { variants: { size: {
	small: "w-2.5 h-2.5",
	medium: "w-3.5 h-3.5",
	large: "w-4 h-4"
} } }), l = o("", { variants: { textCase: {
	capitalize: "capitalize",
	uppercase: "uppercase",
	lowercase: "lowercase"
} } }), u = ({ className: o, color: u = "info", hasCloseButton: d = !1, Icon: f = null, shape: p = "square", size: m = "medium", text: h = "New", textCase: g = "capitalize", fontWeight: _ = "regular" }) => {
	let [v, y] = r(!0), b = {
		small: "xs",
		medium: "sm",
		large: "base"
	}[m] || "base";
	return v ? /* @__PURE__ */ a("div", {
		className: e(s({
			size: m,
			color: u,
			shape: p
		}), "gap-1", o),
		children: [
			f && /* @__PURE__ */ i(f, { className: e(c({ size: m })) }),
			/* @__PURE__ */ i(t, {
				asChild: !0,
				fontWeight: _,
				fontSize: b,
				className: e(l({ textCase: g })),
				children: /* @__PURE__ */ i("span", { children: h })
			}),
			d ? /* @__PURE__ */ i(n, {
				size: m,
				onClick: () => y(!1)
			}) : null
		]
	}) : null;
};
//#endregion
export { u as Badge, s as badgeVariants };
